export const TITLE_TABLE_FOLLOWING_LIST = [
  {
    label: 'library.savePortfolio.COMPANY',
    key: 'organizationName',
  },
  {
    label: 'library.detailsPortfolios.TAX_CODE',
    key: 'taxCode',
  },
  {
    label: 'library.detailsPortfolios.STATUS',
    key: 'status',
  },
  {
    label: 'library.detailsPortfolios.DATE_DOWNLOADED',
    key: 'deliveryDate',
  },
  {
    label: ' ',
    key: 'col6',
  },
]
